import { render, staticRenderFns } from "./BusinessApplicationPriceApplyPreview.vue?vue&type=template&id=5afc9038"
import script from "./BusinessApplicationPriceApplyPreview.vue?vue&type=script&lang=js"
export * from "./BusinessApplicationPriceApplyPreview.vue?vue&type=script&lang=js"
import style0 from "./BusinessApplicationPriceApplyPreview.vue?vue&type=style&index=0&id=5afc9038&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports